module.exports = __webpack_public_path__ + "img/instagram-logo.436c4db3.svg";